<template>
  <div class="indicator-class">
    <SimpleTable
      :show-index="false"
      ref="IndicatorClass"
      table-code="IndicatorClass"
      :columns="columns"
      :data="tableData"
      :loading="loading"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'

export default {
  name: 'IndicatorClass',
  components: {
    SimpleTable
  },
  data() {
    return {
      // 页面数据
      columns: [
        { field: 'name', title: '指标分类', width: 300, tree: true },
        { field: 'unit', title: '计量单位', width: 150 }
      ],
      tableData1: [],
      loading: false
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getTable()
    },
    async getTable() {
      this.tableData = []
      this.loading = true
      const res = await this.$service.get('/indicator-category/listAll', {})
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.IndicatorClass.initialized()
    }
  }
}
</script>

<style scoped>
.indicator-class {
  width: 500px;
  height: 100%;
}
</style>
